import { useEffect } from 'react';

import { useScreenStore } from '../../stores/useScreenStore';

const appTitle = process.env.REACT_APP_TITLE || 'App';

export function useCurrentScreen(screen) {

    const setScreen = useScreenStore(state => state.setScreen);
    document.title = `${appTitle} - ${screen}`;

    useEffect(() => {
        setScreen(screen);
    }, [screen, setScreen]);

}